import React from 'react';
import ClusterMultiSelect from 'app/components/ClusterMultiSelect';
import useClusterMultiSelectProps from './useClusterMultiSelectProps';

export default function PipelinesClusterMultiSelect() {
  const props = useClusterMultiSelectProps();

  return <ClusterMultiSelect {...props} />;
}
